import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M16,24A10.27,10.27,0,0,0,26,13.5V2H22V13.5A6.27,6.27,0,0,1,16,20a6.27,6.27,0,0,1-6-6.5V2H6V13.5A10.27,10.27,0,0,0,16,24Z"/><rect x="4" y="26" width="24" height="4"/>';
export var TextUnderlinedSVG = function TextUnderlinedSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
TextUnderlinedSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(TextUnderlinedSVG);